interface RefreshIconProps {
  width?: string;
  height?: string;
  fill?: string;
  onClick?: () => void;
  className?: string;
}
const RefreshIcon = (props: RefreshIconProps) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
      className={props.className}
    >
      <path
        d="M7.9974 13.3385C6.51962 13.3385 5.26128 12.8191 4.2224 11.7802C3.18351 10.7413 2.66406 9.48299 2.66406 8.00521C2.66406 6.52743 3.18351 5.2691 4.2224 4.23021C5.26128 3.19132 6.51962 2.67188 7.9974 2.67188C8.94184 2.67188 9.76962 2.86354 10.4807 3.24688C11.1918 3.63021 11.8085 4.15521 12.3307 4.82188V3.17188C12.3307 3.02743 12.378 2.90799 12.4724 2.81354C12.5668 2.7191 12.6863 2.67188 12.8307 2.67188C12.9752 2.67188 13.0946 2.7191 13.1891 2.81354C13.2835 2.90799 13.3307 3.02743 13.3307 3.17188V6.40521C13.3307 6.54965 13.2835 6.6691 13.1891 6.76354C13.0946 6.85799 12.9752 6.90521 12.8307 6.90521H9.5974C9.45295 6.90521 9.33351 6.85799 9.23906 6.76354C9.14462 6.6691 9.0974 6.54965 9.0974 6.40521C9.0974 6.26076 9.14462 6.14132 9.23906 6.04688C9.33351 5.95243 9.45295 5.90521 9.5974 5.90521H11.8974C11.4752 5.23854 10.9363 4.69965 10.2807 4.28854C9.62517 3.87743 8.86406 3.67188 7.9974 3.67188C6.78628 3.67188 5.76128 4.09132 4.9224 4.93021C4.08351 5.7691 3.66406 6.7941 3.66406 8.00521C3.66406 9.21632 4.08351 10.2413 4.9224 11.0802C5.76128 11.9191 6.78628 12.3385 7.9974 12.3385C8.86406 12.3385 9.65851 12.108 10.3807 11.6469C11.103 11.1858 11.6418 10.5663 11.9974 9.78854C12.0418 9.69965 12.1141 9.62188 12.2141 9.55521C12.3141 9.48854 12.4141 9.45521 12.5141 9.45521C12.703 9.45521 12.8391 9.51632 12.9224 9.63854C13.0057 9.76076 13.0141 9.90521 12.9474 10.0719C12.5363 11.0608 11.8835 11.8524 10.9891 12.4469C10.0946 13.0413 9.0974 13.3385 7.9974 13.3385Z"
        fill={props.fill || "#1F1F1F"}
      />
    </svg>
  );
};

export default RefreshIcon;
